import { useContext } from 'react';
import RootStoreContext from '../models/StoresProviderContext';

export const useRootStore = () => {
  return useContext(RootStoreContext);
};
